// extracted by mini-css-extract-plugin
export var join_us = "team-module--join_us--2q55K";
export var team_grid = "team-module--team_grid--2zLNr";